
import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";

interface CreateChannelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateChannel: () => void;
  channelName: string;
  setChannelName: (name: string) => void;
  channelDescription: string;
  setChannelDescription: (desc: string) => void;
  isAnnouncement: boolean;
  setIsAnnouncement: (value: boolean) => void;
  isTemporary: boolean;
  setIsTemporary: (value: boolean) => void;
  autoDeleteAfter: number | undefined;
  setAutoDeleteAfter: (minutes: number) => void;
}

export function CreateChannelDialog({
  isOpen,
  onClose,
  onCreateChannel,
  channelName,
  setChannelName,
  channelDescription,
  setChannelDescription,
  isAnnouncement,
  setIsAnnouncement,
  isTemporary,
  setIsTemporary,
  autoDeleteAfter,
  setAutoDeleteAfter,
}: CreateChannelDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Create New Channel</AlertDialogTitle>
          <AlertDialogDescription>
            Enter the details for the new channel.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="name" className="text-right">
              Name
            </Label>
            <Input
              id="name"
              value={channelName}
              onChange={(e) => setChannelName(e.target.value)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="description" className="text-right">
              Description
            </Label>
            <Input
              id="description"
              value={channelDescription}
              onChange={(e) => setChannelDescription(e.target.value)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="isAnnouncement" className="text-right">
              Announcement
            </Label>
            <Switch
              id="isAnnouncement"
              checked={isAnnouncement}
              onCheckedChange={(checked) => setIsAnnouncement(checked)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="isTemporary" className="text-right">
              Temporary
            </Label>
            <Switch
              id="isTemporary"
              checked={isTemporary}
              onCheckedChange={(checked) => setIsTemporary(checked)}
              className="col-span-3"
            />
          </div>
          {isTemporary && (
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="autoDeleteAfter" className="text-right">
                Auto Delete After (minutes)
              </Label>
              <Slider
                id="autoDeleteAfter"
                defaultValue={[autoDeleteAfter || 60]}
                max={1440}
                step={1}
                onValueChange={(value) => setAutoDeleteAfter(value[0])}
                className="col-span-3"
              />
              <span className="col-span-4 text-sm text-muted-foreground text-center">
                {autoDeleteAfter || 60} minutes
              </span>
            </div>
          )}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onCreateChannel}>Create</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
